/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_ReturnedInputs */

const vi_notif_type_returned = /** @type {(inputs: Notif_Type_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hoàn trả`)
};

/**

* @param {Notif_Type_ReturnedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_returned = /** @type {((inputs?: Notif_Type_ReturnedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_ReturnedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_returned(inputs)
});